import { serviceOperationApi } from "./api";

export async function fetchTicketDetail({ accessToken, ticketId, countryId }) {
  const res = await serviceOperationApi.get("/AdminData", {
    params: { idDocument: ticketId, countryId },
    headers: { Authorization: `Bearer ${accessToken}` },
  });

  if (!res.data.data.length) return null;

  const ticket = res.data.data[0];
  return {
    ...ticket,
    movimientos_vs_inicial: ticket.movimientos_vs_inicial ?? false,
  };
}
